export default __webpack_public_path__ + "static/media/christmasLogoSingle.2c1ed3ce.png";